var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1338 3.33997C15.7588 2.87122 16.3213 2.30872 16.7588 1.65247C16.1963 1.90247 15.54 2.08997 14.8838 2.15247C15.5713 1.74622 16.0713 1.12122 16.3213 0.339966C15.6963 0.714966 14.9775 0.996216 14.2588 1.15247C13.6338 0.496216 12.79 0.121216 11.8525 0.121216C10.04 0.121216 8.57126 1.58997 8.57126 3.40247C8.57126 3.65247 8.60251 3.90247 8.66501 4.15247C5.94626 3.99622 3.50876 2.68372 1.88376 0.714966C1.60251 1.18372 1.44626 1.74622 1.44626 2.37122C1.44626 3.49622 2.00876 4.49622 2.91501 5.08997C2.38376 5.05872 1.85251 4.93372 1.41501 4.68372V4.71497C1.41501 6.30872 2.54001 7.62122 4.04001 7.93372C3.79001 7.99622 3.47751 8.05872 3.19626 8.05872C2.97751 8.05872 2.79001 8.02747 2.57126 7.99622C2.97751 9.30872 4.19626 10.2462 5.63376 10.2775C4.50876 11.1525 3.10251 11.6837 1.57126 11.6837C1.29001 11.6837 1.04001 11.6525 0.790009 11.6212C2.22751 12.5587 3.94626 13.09 5.82126 13.09C11.8525 13.09 15.1338 8.12122 15.1338 3.77747C15.1338 3.62122 15.1338 3.49622 15.1338 3.33997Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a9145cb91855db7e5df04d085fa7510b.svg";
export { ForwardRef as ReactComponent };